<div *ngIf="!status" style="width: 100%; height: 100%; position: absolute; z-index: 1;"></div>
<div #pushbutton float-right class="switch demo1">
    <input [disabled]="disabled || !status" type="checkbox" (mouseup)="pressButton($event)" />
    <label></label>
</div>